import init, { reload } from './init';
import { obtainFromDOM, sanitize, baseUrl } from './config';
import { toString } from './render';

if (typeof window === 'object') {
  (() => {
    const throttle = function (type, name, obj) {
      obj = obj || window;
      let running = false;
      const func = function () {
        if (running) {
          return;
        }
        running = true;
        requestAnimationFrame(() => {
          obj.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle('resize', 'optimizedResize');
  })();

  // export API to global W if it is defined
  // useful for old grunt-based FE stack

  if (window.W && window.W.Site && window.W.Site.Common) {
    window.W.Site.Common.marketingHeaderAndFooter = {
      init: (config, nodes) => init(config, nodes, false),
      reload,
      obtainConfigFromDOM: obtainFromDOM,
      baseUrl,
    };
  }
}

export { baseUrl };
export const embed = init;
export const serverSideRenderer = (config = {}, translations = {}, user = null, location = null) => {
  config = sanitize(config);
  return toString(config, translations, user, location);
};
